<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.taskReferrals}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="taskData.subtitle | safeHtml"></span>
	</h5>
</div>
<div class="dx-properties dx-table-entries modal-body">
  <div *ngIf="referrals && referrals.length > 0" style="max-height:600px;padding-left:15px;overflow-y:auto;overflow-x:hidden">
	<div class="row">
		<div class="col-md-2 well-sm"><span class="list-header">{{LOCALIZATION.status}}</span></div>
		<div class="col-md-2 well-sm hidden-xs"><span class="list-header">{{LOCALIZATION.dueDate}}</span></div>
		<div class="col-md-2 well-sm hidden-md hidden-sm hidden-xs"><span class="list-header">{{LOCALIZATION.created}}</span></div>
		<div class="col-md-2 well-sm hidden-md hidden-sm hidden-xs"><span class="list-header">{{LOCALIZATION.closed}}</span></div>
		<div class="col-md-2 well-sm"><span class="list-header">{{LOCALIZATION.referredTo}}</span></div>
		<div class="col-md-2 well-sm hidden-md hidden-sm hidden-xs"><span class="list-header">{{LOCALIZATION.reason}}</span></div>
	</div>	  
	<div *ngFor='let r of referrals; let i = index' [ngClass]="{'dx-stripe':!(i % 2)}" class="row">
		<div class="col-md-2 well-sm"><span class="truncate">{{r.status}}</span></div>
		<div class="col-md-2 well-sm hidden-xs"><span class="truncate">{{r.dateDueStr}}</span></div>
		<div class="col-md-2 well-sm hidden-md hidden-sm hidden-xs"><span class="truncate">{{r.dateCreatedStr}}</span></div>
		<div class="col-md-2 well-sm hidden-md hidden-sm hidden-xs"><span class="truncate">{{r.dateClosedStr}}</span></div>
		<div class="col-md-2 well-sm"><span class="truncate">{{r.owner}}</span></div>
		<div class="col-md-2 well-sm hidden-md hidden-sm hidden-xs"><span class="truncate">{{r.reviewReason || LOCALIZATION.none }}</span></div>
	</div>	
  </div>
  <div *ngIf="!referrals || referrals.length == 0"> <i>{{LOCALIZATION.resultsEmpty}}</i></div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>